<template>
	<v-dialog
		v-model="showDialog"
		max-width="450px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card :tile="$vuetify.breakpoint.xs">
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">{{ dialogTitle }}</v-app-bar-title>
				<v-spacer />
				<v-btn icon dark color="white" @click="showDialog = false">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>

			<v-form class="pa-4" ref="form" v-model="valid" lazy-validation>
				<v-menu
					ref="menu"
					v-model="menu"
					:close-on-content-click="false"
					transition="scale-transition"
					offset-y
					max-width="290px"
					min-width="auto"
				>
					<template v-slot:activator="{ on, attrs }">
						<v-text-field
							readonly
							outlined
							dense
							v-model="setReceivingShippingDate"
							v-bind="attrs"
							v-on="on"
							:rules="[rules.required(setReceivingShippingDate)]"
							@click="menu = true"
						/>
					</template>
					<v-date-picker
						v-model="setReceivingShippingDate"
						no-title
						scrollable
						@input="menu = false"
						locale="ja"
					>
					</v-date-picker>
				</v-menu>
			</v-form>
			<v-card-actions>
				<v-row no-gutters class="pb-2">
					<v-col cols="4" />
					<v-col cols="4">
						<v-row no-gutters justify="center">
							<v-btn color="secondary" @click="updateDate()">
								<v-icon class="mr-2">mdi-plus</v-icon>
								登録する
							</v-btn>
						</v-row>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import rules from "../../../helper/rules"
import moment from "moment"
import "moment/locale/ja"

export default {
	props: {
		dialog: {
			type: Boolean,
			default: false,
		},
		receivingShippingId: {
			required: true,
		},
		receivingShippingDate: {
			type: String,
			default: "",
		},
		dialogTitle: {
			type: String,
			default: "",
		},
		dateType: {
			type: String,
			default: "",
		},
	},
	filters: {
		dateFormatter(date) {
			if (!date) return
			moment.locale("ja")
			return moment(date).format("MM/DD(dd)")
		},
		monthFormatter(date) {
			if (!date) return
			moment.locale("ja")
			return moment(date).format("YYYY年MM月")
		},
	},
	data() {
		return {
			rules: rules,
			valid: false,
			menu: false,
			date: "",
		}
	},

	methods: {
		updateDate() {
			const headers = authenticate.setHeader()

			let params = {}
			if (this.dateType == "planned") {
				params.planned_operation_date = this.receivingShippingDate
			} else if (this.dateType == "actual") {
				params.actual_operation_date = this.receivingShippingDate
			}

			axios
				.put(
					`/erp/v1/rubber/stocks/${this.receivingShippingId}`,
					{ receiving_shipping: params },
					{
						headers,
					}
				)
				.then((res) => {
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "更新しました",
					})
					this.showDialog = false
					this.$emit("reload-show", res.data.receiving_shipping)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(newVal) {
				return this.$emit("update:dialog", newVal)
			},
		},
		setReceivingShippingDate: {
			get() {
				return this.receivingShippingDate
			},
			set(newVal) {
				return this.$emit("update:receivingShippingDate", newVal)
			},
		},
	},
}
</script>
